import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import classnames from 'classnames';

import styles from './Popover.module.scss';

const CustomPopover = ({ children, placement, text, trigger, id, className, ...props }) => (
  <OverlayTrigger
    {...props}
    trigger={trigger ?? ['hover', 'focus']}
    placement={placement ?? 'top'}
    overlay={
      <Popover id={id ?? 'boon-popover'} className={classnames(styles.popOver, className)}>
        {text}
      </Popover>
    }
  >
    {children}
  </OverlayTrigger>
);

export default CustomPopover;
